import { getActiveChipName } from "core-integration/src/store/chips/reducers";
import {
  getFreeTransfersRemaining,
  getTransferCosts,
} from "core-integration/src/store/squad/reducers";
import { useSelector } from "react-redux";
import { usePlosTranslations } from "../../../contexts/PlosTranslationsContext";
import { integerToMoneyWithCurrency } from "../../../utils/money";
import { scoreboardPanelWrap } from "../scoreboard.css";
import ScoreboardPanel from "../ScoreboardPanel";
import { CommonScoreboardProps } from "../types";

/** The CostScoreboard variant is used on the Transfers page when the transfers status is "cost" */
const CostScoreboard = ({
  currencyDivisor,
  isBudgetExceeded,
  toSpend,
  proposedElements,
  isNeedElements,
  elementTypesByPosition,
}: CommonScoreboardProps) => {
  const { scoreboard } = usePlosTranslations();
  const activeChipName = useSelector(getActiveChipName);
  const freeTransfersRemaining = useSelector(getFreeTransfersRemaining);

  const freeTranfersRemainingValue =
    activeChipName === "wildcard" || activeChipName === "freehit"
      ? "Unlimited"
      : `${freeTransfersRemaining}`;

  const transferCosts = useSelector(getTransferCosts);

  const budgetValue = integerToMoneyWithCurrency(toSpend, currencyDivisor);
  const transferCostsValue = scoreboard.transferCostsValue(transferCosts);
  const playersSelectedValue = `${Object.keys(proposedElements).length} / ${
    Object.keys(elementTypesByPosition).length
  }`;

  return (
    <div className={scoreboardPanelWrap}>
      <ScoreboardPanel
        header={scoreboard.playersSelected}
        value={playersSelectedValue}
        status={isNeedElements ? "error" : "success"}
      />
      <ScoreboardPanel
        header={scoreboard.budget}
        value={budgetValue}
        status={isBudgetExceeded ? "error" : "success"}
      />
      <ScoreboardPanel
        header={scoreboard.freeTransfers}
        value={freeTranfersRemainingValue}
      />
      <ScoreboardPanel
        header={scoreboard.cost}
        value={transferCostsValue}
        status={transferCosts > 0 ? "error" : "default"}
      />
    </div>
  );
};

export default CostScoreboard;
